var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CompanyHeader',{attrs:{"img_header":_vm.header_image,"header":"รายงาน POS","link_back":"managepos"}}),_c('Set_record_information')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }